'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppConfigProvider = function (_React$Component) {
  (0, _inherits3.default)(AppConfigProvider, _React$Component);

  function AppConfigProvider(props, context) {
    (0, _classCallCheck3.default)(this, AppConfigProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AppConfigProvider.__proto__ || (0, _getPrototypeOf2.default)(AppConfigProvider)).call(this, props, context));

    _this.config = props.config;
    return _this;
  }

  (0, _createClass3.default)(AppConfigProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { config: this.config };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);
  return AppConfigProvider;
}(_react2.default.Component);

AppConfigProvider.propTypes = {
  config: _react.PropTypes.any
};
AppConfigProvider.defaultProps = {
  config: {}
};
AppConfigProvider.childContextTypes = {
  config: _react.PropTypes.any
};
exports.default = AppConfigProvider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/chemist/dist/helpers/AppConfigProvider.js
// module id = 357
// module chunks = 0